import { render, staticRenderFns } from "./ElementOptionItem.vue?vue&type=template&id=487d405a"
import script from "./ElementOptionItem.vue?vue&type=script&lang=js"
export * from "./ElementOptionItem.vue?vue&type=script&lang=js"
import style0 from "./ElementOptionItem.vue?vue&type=style&index=0&id=487d405a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports